<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div
        class="bg-light border-right"
        id="sidebar-wrapper"
        v-if="role != ('pasien' || 'antrian')"
      >
        <Sidebar active="" />
      </div>
      <div
        :id="
          role != ('pasien' || 'antrian')
            ? 'page-content-wrapper'
            : 'page-content-no-sidebar'
        "
      >
        <div class="container">
          <center class="pt-4 px-4">
            <h2 v-if="role == 'pasien'" class="mb-2">
              Pendaftaran Rawat Jalan PBEC
            </h2>
            <h2 v-else class="mb-2">Menu Akses Cepat</h2>
            <h4 v-if="role == 'pasien'" class="font-body text-muted mb-4">
              Apakah Anda merupakan pasien baru atau pasien lama?
            </h4>
            <h4 v-else class="font-body text-muted mb-4">
              Akses Cepat untuk {{ roleLabel }}
            </h4>

            <b-row class="text-center justify-content-md-center">
              <b-col
                md="2"
                sm="6"
                width="6"
                class="mb-1 mt-3 px-2 col-6"
                v-for="(item, index) in menus.filter((menu) =>
                  menu.authorized.includes(role)
                )"
                v-bind:key="index + 1"
              >
                <a
                  :href="item.link"
                  target="_blank"
                  :class="`card py-2 card-${item.class}`"
                  v-if="item.fullUrl"
                >
                  <h1 class="mt-3">
                    <i
                      :class="`material-symbols-outlined text-${item.class}`"
                      >{{ item.icon }}</i
                    >
                  </h1>
                  <h5 class="mb-3">{{ item.label }}</h5>
                </a>
                <router-link
                  :to="item.link"
                  :class="`card py-2 card-${item.class}`"
                  v-else
                >
                  <h1 class="mt-3">
                    <i
                      :class="`material-symbols-outlined text-${item.class}`"
                      >{{ item.icon }}</i
                    >
                  </h1>
                  <h5 class="mb-3">{{ item.label }}</h5>
                </router-link>
              </b-col>
            </b-row>
          </center>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
h1 > i {
  font-size: 2.5rem;
}
</style>
<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
// import {menus,roleLabel,role} from '@/config.js';
export default {
  name: "Home",
  components: {
    Navbar,
    Sidebar,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      menus: [],
      roleLabel: "",
      role: "",
      token: "",
    };
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.role = this.$store.state.role;
    this.roleLabel = this.$store.state.roleLabel;
    this.menus = this.$store.state.menus;
    this.token = this.$store.state.token;

    //console.log(this.token);
    if (this.token) {
      let result;
      try {
        // result = await this.$store.state.HTTP.get("pasien");
        result = await this.$store.state.HTTP.get("pasien?per_page=1");
        //console.log(result);
      } catch (error) {
        //console.log(error);
      }
      //console.log(result);
      if (!result) {
        try {
          this.$store.dispatch("logout");
          this.$router.push("/login");
          // this.$router.go();
        } catch (e) {
          //console.log(e);
        }
      } else {
        if (this.role == "antrian") {
          // this.$router.push('/antrian/pasien');
        }
      }
    }
  },
};
</script>
